import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../comun/services/api/base-api.service';
import { MultiGuardado, MultiTarificacionSalud, PolizaSalud } from '../../../comun/model/salud.model';
import { Observable } from 'rxjs';
import { ValidacionColectivas } from '../../../comun/model/recomendador.model';

@Injectable({
  providedIn: 'root'
})
export class PolizaSaludApiService extends BaseApiService {
  multiTarificarPoliza(poliza: PolizaSalud, colectivas: string[]): Observable<MultiTarificacionSalud> {
    return this.invocarSeguros<MultiTarificacionSalud>('POST', 'salud/propuesta/simulacion', { propuesta: poliza, colectivas: colectivas });
  }

  colectivasValidasTarificacionPorEdad(fechasNacimiento: string[]): Observable<ValidacionColectivas> {
    const params = fechasNacimiento.map(f => `fechasNacimiento=${encodeURIComponent(f)}`).join('&');
    return this.invocarSeguros<ValidacionColectivas>(
      'GET',
      `salud/propuesta/validar-colectivas-edad?${params}`
    );
  }

  multiGuardarPropuesta(multiGuardado: MultiGuardado): Observable<PolizaSalud> {
    return this.invocarSeguros<PolizaSalud>('POST', 'salud/propuesta', multiGuardado);
  }

}
